<template>
    <div class="service-tiket-wrapper">
        <div class="tit">{{ ticketQuota }}</div>
        <List :data="listData" />
    </div>
</template>

<script>
import List from "./List";

export default {
    name: "ServiceTiket",
    props: ["lang", "date", "channel"],
    components: {
        List
    },
    data() {
        return {
            listData: {}
        };
    },
    computed: {
        ticketQuota() {
            return this.$t("zhiji.serviceData.ticketQuota");
        }
    },
    watch: {
        channel() {
            this.queryTiketIndicator();
        },
        date() {
            this.queryTiketIndicator();
        },
        lang() {
            this.queryTiketIndicator();
        },
        ticketQuota() {
            this.queryTiketIndicator();
        }
    },
    methods: {
        queryTiketIndicator() {
            this.zhiji
                .requestByServiceName("queryTiketIndicator", {
                    lang: this.lang,
                    date: this.date,
                    channel: this.channel
                })
                .then(resp => {
                    this.listData = resp;
                });
        }
    },
    mounted() {
        this.queryTiketIndicator();
    }
};
</script>

<style lang="scss" scoped>
.service-tiket-wrapper {
    margin-bottom: 27px;
    .tit {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-weight: bold;
    }
}
</style>
